import React, { Children } from "react";

export default function WizardButton(props) {
  const { icon, onClick, children, enabled } = props;
  return (
    <div
      onClick={() => enabled && onClick()}
      className="tt-wizard-button"
      style={{
        display: "flex",
        backgroundColor: "#F0522E",
        color: "#fff",
        width: "50%",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "22px",
        fontWeight: "bold",
        margin: "10px 5px",
        cursor: "pointer",
        opacity: enabled ? 1 : 0.5,
      }}
    >
      {icon == "left" && (
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="46"
            height="45"
            viewBox="0 0 46 45"
            fill="none"
          >
            <rect
              x="45.5"
              y="45"
              width="45"
              height="45"
              rx="3"
              transform="rotate(180 45.5 45)"
              fill="#F0522E"
            />
            <path
              d="M20.75 22.5L27.2188 28.9687L25.25 30.9375L16.8125 22.5L25.25 14.0625L27.2187 16.0312L20.75 22.5Z"
              fill="white"
            />
          </svg>
        </div>
      )}

      <div>{children}</div>

      {icon == "right" && (
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="45"
            height="45"
            viewBox="0 0 45 45"
            fill="none"
          >
            <rect width="45" height="45" rx="3" fill="#F0522E" />
            <path
              d="M24.75 22.5L18.2812 16.0313L20.25 14.0625L28.6875 22.5L20.25 30.9375L18.2812 28.9688L24.75 22.5Z"
              fill="white"
            />
          </svg>
        </div>
      )}
    </div>
  );
}
